import { Directive, HostListener } from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";

@Directive({
  selector: '[inputTrim]',
})
export class JobGroupInputTrimDirective {
  constructor(private ngControl: NgControl) {
    this.trimValueAccessor(ngControl.valueAccessor);
  }

  @HostListener('blur')
  blurHandler() {
    const value = this.ngControl.value;
    this.ngControl.control.setValue(this.prepareValue(value));
  }

  @HostListener("input", ["$event.target.value"])
  inputHandler(val: string) {
    this.ngControl.control.setValue(this.prepareValue(val));
  }

  private trimValueAccessor(valueAccessor: ControlValueAccessor) {
    const original = valueAccessor.registerOnChange;
  
    valueAccessor.registerOnChange = (fn: (_: unknown) => void) => {
      return original.call(valueAccessor, (value: unknown) => {
        return fn(this.prepareValue(value));
      });
    };
  }

  private prepareValue(value: unknown) {
    let preparedValue = value;
    if (typeof preparedValue === 'string') {
      preparedValue = preparedValue.replace(/\s*/g, '');
    }
    return preparedValue;
  }
}
